export const PRICING_ADJUSTMENT_TITLE = 'Lock Desk Adjustment' as const

export interface PricingAdjustmentValues {
  bips?: number | null
  dollarAmount?: number | null
}

export interface PricingAdjustmentDetails {
  id: number
  applicationId: number
  bips?: number | null
  dollarAmount?: number | null
  createdAt?: string | null
  createdBy?: string | null
}
